// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import letterStatusEntity from './entities/letter-status.json';
import letterStatusMenu from '../pages/letter-status/menu.json';
import letterStatusFullForm from '../pages/letter-status/forms/full.json';
import letterStatusContextForm from '../pages/letter-status/forms/context.json';
import letterStatusMiniForm from '../pages/letter-status/forms/mini.json';
import letterStatusLookupForm from '../pages/letter-status/forms/lookup.json';
import letterStatusTableView from '../pages/letter-status/views/table.json';
import letterStatusDashboardView from '../pages/letter-status/views/dashboard.json';

/** Тип запису «Статус листа» зі сторінками пакета: меню, форми та подання з pages/letter-status/. */
export const letterStatusDefinition: IRecordTypeDefinition = {
  ...letterStatusEntity,
  views: assembleViewSet({
      table: letterStatusTableView,
      dashboard: letterStatusDashboardView,
  }),
  form: letterStatusFullForm,
  forms: { full: letterStatusFullForm, context: letterStatusContextForm, mini: letterStatusMiniForm, lookup: letterStatusLookupForm },
  menu: letterStatusMenu,
} as IRecordTypeDefinition;
